<template>
  <div>
    <v-card-text class="pa-0" style="height: 584px; overflow-y: auto;" v-if="event_group">
      <div class="loading" v-show="!active">
        <v-progress-circular class="loading-icon" indeterminate v-bind:size="50"></v-progress-circular>
      </div>

      <div class="elevation-3 mb-1"  v-if="active">
        <EventForm :scrollable="false" height="auto" :disable_event_group_edit="true" :event_group="event_group.uuid" :disable_get_profile="true"></EventForm>
      </div>

      <v-expansion-panel v-if="active">
        <v-expansion-panel-content v-for="event in events" :key="event.uuid">
          <div slot="header">{{title(event)}}</div>
          <v-card :class="$dark() ? 'grey darken-4' : 'grey lighten-4'">
            <EventForm :scrollable="false" :disable_event_group_edit="true" height="auto" :id="event.uuid" :disable_get_profile="true"></EventForm>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-card-text>
  </div>
</template>

<script>

import EventForm from './Form'
import ChannelModel from '@/models/channel.js'
import EventModel from '@/models/event.js'

export default {
  props: ['id'],
  components: {
    EventForm
  },
  data () {
    var ch = undefined;
    if(this.id) ch = this.$cloudserver.channel("events:event_group_by_event:"+this.id);
    return {
      ws_channel: ch,
      events: undefined,
      event_group: undefined,
      active: this.$route.query.tab == "schedule"
    }
  },
  watch: {
    id (newVal, oldVal) {
      if (!oldVal && newVal && !this.ws_channel) {
        this.ws_channel = this.$cloudserver.channel("events:event_group_by_event:"+newVal);
        this.ws_channel.join();
      }
    },
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.event_group = newVal;
          this.events = this.event_group["events"];
        }
      },
      deep: true
    },
    "$route.query.tab" (newVal) {
      if(newVal == "schedule") {
        setTimeout(() => {
          this.active = true;
        },200);
      }

    }
  },
  created () {
    if(this.ws_channel) this.ws_channel.join();
    this.$store.dispatch("get_profile");
  },
  methods: {
    save(close) {

    },
    title (event) {
      var ch = EventModel.output_channel(event);
      return ChannelModel.title(ch) + ": " + EventModel.title(event);
    }
  }

}
</script>

<style scoped>
.loading {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 9999;
}
.loading .loading-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}
</style>
